import { handleAction } from "redux-actions";

import { profileCompletenessData } from "lib/profile";
import positionReducers from "redux/positions/reducers";
import questionReducers from "redux/questions/reducers";

import {
    candidateIncrAnswerCount,
    candidateSetAutoApply,
    candidateSetProfileData,
} from "redux/candidate/actions";

export default {
    ...positionReducers,
    questions: questionReducers,

    answerCount: handleAction(
        candidateIncrAnswerCount,
        (state, { payload }) => state + (Number(payload) || 0),
        0,
    ),

    autoApplyEnabled: handleAction(candidateSetAutoApply, (state, { payload }) => payload, null),

    profile: handleAction(
        candidateSetProfileData,
        (state, { payload }) => ({
            ...payload,
            completeness: profileCompletenessData(payload),
        }),
        null,
    ),

    applications: (state = {}) => state,
    complete: (state = false) => state,
    firstName: (state = "") => state,
    gender: (state = "") => state,
    hasJobRefs: (state = false) => state,
    hasPrefs: (state = true) => state,
};
